<div class="sidebar">
	<app-sidebar-header [title]="'bookingDetails.fareTaxes.title.fareAndTaxes' | ibeadmin | async"></app-sidebar-header>

		<ng-container *ngIf="noFaresError">
			<app-notification 
			[classes]="'top-gap left-gap right-gap'" [style]="'alert'" [icon]=" 'icons.svg#airport--delays' ">
				<div message>
					{{'bookingDetails.text.somethingWentWrong' | ibeadmin | async}}
				</div>
			</app-notification>
		</ng-container>
	
		<div *ngIf="isLoading" class="sidebar">
			<app-loading></app-loading>
		</div>

		<ng-container *ngIf="!isLoading && !noFaresError">
			<div class="fare-and-taxes-flight-summary">
				<app-svg class="fare-and-taxes-flight-summary__title__icon" 
					svg="sprite.svg#color_icon--plane" 
					aria-hidden="true" 
					[alt]="'bookingDetails.fareTaxes.alt.planeIcon' | ibeadmin | async">
				</app-svg>
				<h3 class="fare-and-taxes-flight-summary__title">
					{{'bookingDetails.title.flightsTotal' | ibeadmin | async}}
				</h3>
				<div class="fare-and-taxes-flight-summary__price {{bookAwardFlight ? 'book-award' : ''}}">
					<span *ngIf="totalMiles > 0">
						{{ totalMiles + 'M' | indracurrency }} + 
					</span>
					{{ totalPrice + currency | indracurrency }}
				</div>
			</div>

			<div class="sidebar__body sl--scrollable" #sidebar__body>


				<div class="fare-and-taxes-flight-main" *ngFor="let passenger of taxPerPassenger">
					<h3>{{'bookingDetails.label.chargesPer' | ibeadmin | async}} {{passenger.name | ibeadmin | async }}</h3>

					<div class="fare-and-taxes-flight-main-list">
						<div class="fare-and-taxes-flight-main-list--title border">
							{{'bookingDetails.label.airTransportationTaxes' | ibeadmin | async}}
						</div>

						<ul class="body border">
							<li class="extras-feature extras-feature__fare-and-taxes">
								<div class="extras-feature__label" *ngIf="!bookAwardFlight">
									{{'bookingDetails.label.fare' | ibeadmin | async}}
								</div>
								<div class="extras-feature__label" *ngIf="bookAwardFlight">
									{{ 'bookingDetails.fareTaxes.text.miles' | ibeadmin | async }}
								</div>
								<span class="price">
									{{ INDRA_getTotalBaseFare(passenger) | indracurrency }}
								</span>
							</li>
							<li class="extras-feature extras-feature__fare-and-taxes" *ngIf="bookAwardFlight">
								<div class="extras-feature__label" >
									{{ 'bookingDetails.fareTaxes.text.tickerServiceFee' | ibeadmin | async }}
								</div>
								<span class="price">
									{{ passenger.totalFare.obfee + currency | indracurrency }}
								</span>
							</li>
							<li class="extras-feature extras-feature__fare-and-taxes" 
								*ngFor="let taxSection of getTaxListSection1ByPassenger(passenger.totalFare.taxList)">
								<div class="extras-feature__label">
									{{ INDRA_printTaxDescription(taxSection) }}
								</div>
								<span class="price">
									{{ taxSection.amount + currency | indracurrency }}
								</span>
							</li>
						</ul>

					</div>

					<div class="fare-and-taxes-flight-main-list" *ngIf="hasTaxList(passenger.totalFare.taxList)">
						<div class="fare-and-taxes-flight-main-list--title border">
							{{'bookingDetails.label.othercharges' | ibeadmin | async}} {{passenger.name | ibeadmin | async}}
						</div>

						<ul class="body border">
							<li class="extras-feature extras-feature__fare-and-taxes" 
								*ngFor="let taxSection of getTaxListSection2ByPassenger(passenger.totalFare.taxList)">
								<div class="extras-feature__label">
									{{ INDRA_printTaxDescription(taxSection) }}
								</div>
								<span class="price">
									{{ taxSection.amount + currency | indracurrency }}
								</span>
							</li>
		
						</ul>

					</div>

					<div class="fare-and-taxes-flight-main--total">
						<div class="fare-and-taxes-flight-main--total__label">
							{{passenger.count}} {{passenger.name | ibeadmin | async}}
						</div>
						<span class="fare-and-taxes-flight-main--total__price">
							{{ INDRA_getTotalMiles(passenger) }}{{ (passenger.totalFare.fare + passenger.totalFare.taxes + passenger.totalFare.obfee) + currency | indracurrency }}
						</span>
					</div>

				</div>

				<div class="sidebar-flight-text">
					<p>
						<a class="link extras-feature__link" 
							[attr.aria-label]="'bookingDetails.text.closeDialog' | ibeadmin | async" 
							(click)="INDRA_handleClose()" 
							href="javascript:;" 
							role="button">
							{{ 'bookingDetails.text.closeThisWindow' | ibeadmin | async }}
						</a>
					</p>
				</div>
			</div>

		</ng-container>



	<div #sidebar__footer class="sidebar__footer ">
	</div>

</div>
